module.exports = __webpack_public_path__ + "static/img/inquire_icon.c5cde4f4.svg";